
import { createContext, useReducer } from "react";
import InvoiceReducer from "./InvoiceReducer";

const INITIAL_STATE = {
    invoices: [],
    count: 1,
    isFetching: false,
    error: false,
    invoice: {},
    settings: {},
    envois: [],
    allEnvois: [],
    envoisDownload: [],
    countGlobal: 1,
    sumCost: 0,
    sumMontant: 0,
    historiesRamassage: [],
    historiesDepot: [],
    isFetchingAdd: false,
    errorAdd: false,
    isFetchingEnvoisRamassageDepot: false,
    errorEnvoisRamassageDepot: false,
    isFetchingUpdate: false,
    errorUpdate: false, 
    message: "",
    isFetchingDelete: false,
    errorDelete: false,
};


export const InvoiceContext = createContext(INITIAL_STATE);

export const InvoiceContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(InvoiceReducer, INITIAL_STATE);
    
    return (
      <InvoiceContext.Provider
        value={{
          invoices: state.invoices,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          invoice: state.invoice,
          settings: state.settings,
          envois: state.envois,
          allEnvois: state.allEnvois,
          envoisDownload: state.envoisDownload,
          countGlobal: state.countGlobal,
          sumCost: state.sumCost,
          sumMontant: state.sumMontant,
          historiesRamassage: state.historiesRamassage,
          historiesDepot: state.historiesDepot,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          isFetchingEnvoisRamassageDepot: state.isFetchingEnvoisRamassageDepot,
          errorEnvoisRamassageDepot: state.errorEnvoisRamassageDepot,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          message: state.message,
          isFetchingDelete: state.isFetchingDelete,
          errorDelete: state.errorDelete,
          dispatch,
        }}
      >
        {children}
      </InvoiceContext.Provider>
    );
  };